export default class {

    constructor() {
        const popupsCloseBtns = document.querySelectorAll('.alertClose')

        popupsCloseBtns.forEach(close => {
            close.removeEventListener('click', this.close)
            close.addEventListener('click', this.close)
        })
    }

    body = (status = false) => {
        !status ? document.body.classList.add('lock') : document.body.classList.remove('lock')
    }

    open = (popupName) => {
        this.body()
        const popup = document.querySelector(popupName)
        popup.style.display = 'flex'
        setTimeout(() => {
            popup.classList.add('init')
        }, 100)
    }

    close = () => {
        const opend = document.querySelector('.alert.init')
        if (opend) {
            opend.classList.remove('init')
        }
        setTimeout(() => {
            if (opend) {
                opend.style.display = 'none'
            }
            this.body(true)
        }, 100)
    }
}